const ADDRESS = {
  init: function () {
    this.attributes = {
      expanded: 'aria-expanded',
      confirmMessage: 'data-confirm-message',
    };
    this.addressForm = document.querySelectorAll('.user-area-address__form');
    if (this.addressForm.length <= 0) {
      return;
    }

    this.countrySelect = document.querySelectorAll('[data-address-country-select]');
    this.setupCountries();

    const buttonNewAddress = document.querySelector('.button--new-address');
    const buttonEditAddress = document.querySelectorAll('.user-area-address__list-item--buttons .button--edit');
    const buttonDeleteAddress = document.querySelectorAll('.user-area-address__list-item--buttons .button--delete');
    const buttonCancel = document.querySelectorAll('.user-area-address__form button[type="reset"]');
    const buttonClose = document.querySelectorAll('.user-area-address__form .button-close');

    buttonNewAddress.addEventListener('click', () => {
      const newAddressForm = document.getElementById('AddAddress');
      this.show(newAddressForm);
    });

    this.addressForm.forEach((element) => {
      element.addEventListener('click', () => {
        this.checkBackdrop(element, event);
      });
    });

    buttonEditAddress.forEach((element) => {
      element.addEventListener('click', () => {
        const parentDiv = element.closest('.user-area-address__list-item');
        const targetElement = parentDiv.querySelector('.user-area-address__form');
        this.show(targetElement);
      });
    });

    buttonDeleteAddress.forEach((element) => {
      element.addEventListener('click', () => {
        this.delete(element);
      });
    });

    buttonCancel.forEach((element) => {
      element.addEventListener('click', () => {
        const targetElement = element.closest('.user-area-address__form');
        this.hide(targetElement);
      });
    });
    
    buttonClose.forEach((element) => {
      element.addEventListener('click', () => {
        const targetElement = element.closest('.user-area-address__form');
        this.hide(targetElement);
      });
    });
  },

  setupCountries: function () {
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.countrySelect.forEach((select) => {
        const formId = select.dataset.formId;
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  },

  show: function (target) {
    target.showModal();
  },

  hide: function (target) {
    target.close();
  },

  delete: function (element) {
    if (confirm(element.getAttribute(this.attributes.confirmMessage))) {
      Shopify.postLink(element.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  },

  checkBackdrop: function (target, event) {
    const rect = target.getBoundingClientRect();
    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      this.hide(target);
    }
  },
};

const PARTNERS = {
  init: function () {
    this.partnersModal = document.querySelectorAll('.adventure-pass-partners__carousel-item-popup');
    if (!this.partnersModal) {
      return;
    }

    const buttonOpen = document.querySelectorAll('.adventure-pass-partners__carousel-item .bottom');
    const buttonClose = document.querySelectorAll('.adventure-pass-partners__carousel-item-popup .button-close');
    
    this.partnersModal.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.checkBackdrop(element, event);
      });
    });

    buttonOpen.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        const parentElement = element.closest('.adventure-pass-partners__carousel-item');
        const targetElement = parentElement.querySelector('.adventure-pass-partners__carousel-item-popup');
        this.show(targetElement);
      });
    });

    buttonClose.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        const targetElement = element.closest('.adventure-pass-partners__carousel-item-popup');
        this.hide(targetElement);
      });
    });
  },

  show: function (target) {
    target.showModal();
  },

  hide: function (target) {
    target.close();
  },

  checkBackdrop: function (target, event) {
    const rect = target.getBoundingClientRect();
    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      this.hide(target);
    }
  },
};

const PASSWORD_TOGGLE = {
  init: function () {
    this.fields = document.querySelectorAll('.field-pass');
    if (!this.fields) {
      return;
    }
    this.fields.forEach((field) => {
      const button = field.querySelector('.toggle-pass');
      const input = field.querySelector('.input-pass');
      if (button && input) {
        button.addEventListener('click', () => this.togglePassword(input, button));
      }
    });
  },

  togglePassword: function (input, button) {
    if (input.getAttribute('type') === 'password') {
      input.setAttribute('type', 'text');
      button.classList.add('show-pass');
    } else {
      input.setAttribute('type', 'password');
      button.classList.remove('show-pass');
    }
  },
};

document.addEventListener('DOMContentLoaded', () => {
  ADDRESS.init();
  PARTNERS.init();
  PASSWORD_TOGGLE.init();
});